import { Separator, Skeleton } from '@common-web/index.js';
import { formatCurrency } from '@utils/utils.js';
import { Flex, Image } from 'antd';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import placeholderImage from '../../../../../../assets/placeholder.png';

const LineItemCard = ({ product }) => {
  const { currency } = useSelector((state) => state.tenantData?.tenant ?? {});
  const {
    id,
    name,
    net_price,
    category,
    sku,
    quantity,
    cover_image,
    external_url,
    option_values = [],
    removed_items,
    total_net_price,
    added_items,
  } = product;
  const variants = option_values;

  const openExternalUrl = useCallback(() => {
    if (!external_url) {
      return;
    }
    window.open(external_url);
  }, [external_url]);

  return (
    <Flex align="center" justify="space-between" gap={32} style={{ width: '100%' }}>
      <Flex align="center" gap={12}>
        <Image
          width={92}
          height={92}
          className="image-border"
          src={cover_image?.sizes?.thumbnail || placeholderImage}
          alt="Loading..."
          wrapperClassName="flexShrink0"
          preview={false}
          loading="lazy"
          placeholder={<Skeleton width={92} height={92} borderRadius={6} />}
        />
        <Flex gap={16} justify={'space-between'}>
          <Flex vertical gap={8}>
            <Separator className="lineHeight1 fs-12" style={{ '--spbw': '6px' }}>
              <div>
                <span style={{ color: 'var(--gray-500)' }}>Item ID:</span> {id}
              </div>
              {sku && (
                <div>
                  <span style={{ color: 'var(--gray-500)' }}>SKU:</span> {sku}
                </div>
              )}
            </Separator>
            <div className={`fw-600 ${external_url ? 'cursor-pointer' : ''}`} onClick={openExternalUrl}>
              {name || '-'}
            </div>
            <Separator className="lineHeight1 fs-12" style={{ '--spbw': '6px', flexWrap: 'wrap' }}>
              <div>
                <span style={{ color: 'var(--gray-500)' }}>Category:</span> {category?.name}
              </div>
              {!!variants?.length &&
                variants?.map((variant) => (
                  <div key={variant?.type} style={{ margin: '4px' }}>
                    <span style={{ color: 'var(--gray-500)' }}>{variant?.type}:</span> {variant?.value}
                  </div>
                ))}
            </Separator>
          </Flex>
        </Flex>
      </Flex>
      <Flex vertical gap={8} className="flexShrink0">
        <Flex gap={2} className="fs-12" justify="end">
          <div className="fw-700 lineHeight1" style={{ color: 'var(--ant-color-primary)' }}>
            {formatCurrency({ currency, price: net_price })}
          </div>
        </Flex>
        {removed_items && (
          <Flex gap={2} className="fs-12" justify="end">
            <span style={{ color: 'var(--gray-500)' }}>Items Removed:</span>
            <span className="fw-500">{removed_items}</span>
          </Flex>
        )}
        {added_items && (
          <Flex gap={2} className="fs-12" justify="end">
            <span style={{ color: 'var(--gray-500)' }}>Items Added:</span>
            <span className="fw-500">{added_items}</span>
          </Flex>
        )}
        <Flex gap={2} className="fs-12" justify="end">
          <span style={{ color: 'var(--gray-500)' }}>Quantity:</span>
          <span className="fw-500">{quantity}</span>
        </Flex>
        {(total_net_price || total_net_price === 0) && (
          <Flex gap={4} className="fs-12" justify="end">
            <span className="fw-600" style={{ color: 'var(--gray-500)' }}>
              Total:
            </span>
            <span className="fw-600">{formatCurrency({ price: total_net_price, currency })}</span>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default LineItemCard;
